export const INACTIVE = 'Inativo'